<fury-page-layout mode="card">
  <fury-page-layout-header>
    <fury-breadcrumbs
      [@fadeInRight]
      current="Service provider"
    ></fury-breadcrumbs>
  </fury-page-layout-header>
  <fury-page-layout-content [@fadeInUp]>
    <div class="block_area">
      <fury-common-kpi-blocks [mainPage]="'serviceProvider'" [data]="kpiData"></fury-common-kpi-blocks>
    </div>

    <div class="wrapper">
      <div class="tab_section">
        <button
          (click)="toggleTab(false)"
          [ngClass]="{ active: !isShowCompany }"
        >
          Add New Company
        </button>
        <button (click)="toggleTab(true)" [ngClass]="{ active: isShowCompany }">
          All Companies
        </button>
      </div>
      <div class="card">
        <div [style.display]="!isShowCompany ? 'block' : 'none'">
          <fury-add-company [services]="services"></fury-add-company>
        </div>
        <div *ngIf="isShowCompany">
          <div class="tab_panel">
            <h3>Company List</h3>
            <mat-tab-group (selectedTabChange)="onTabChange($event)">
              <mat-tab label="Pending">
                <fury-service-provider-table
                  [dataSource]="companies"
                  [searchForm]="searchForm"
                  [isLoading]="isLoading"
                  (search)="handleSearch($event)"
                  (handlePaymentInfo)="handlePaymentInfo($event)"
                ></fury-service-provider-table>
                <mat-paginator
                  *ngIf="this.totalCount > 0"
                  [pageSizeOptions]="[5, 30, 50, 100, 9999]"
                  [pageSize]="pageSize"
                  [length]="totalCount"
                  [pageIndex]="pageIndex"
                  (page)="pageSizeChange($event)"
                  showFirstLastButtons
                  [selectConfig]="selectConfig"
                  [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
                  aria-label="Select page of periodic elements"
                >
                </mat-paginator>
              </mat-tab>
              <mat-tab label="Approved">
                <fury-service-provider-table
                  [dataSource]="companies"
                  [searchForm]="searchForm"
                  [isLoading]="isLoading"
                  (search)="handleSearch($event)"
                  (handlePaymentInfo)="handlePaymentInfo($event)"
                ></fury-service-provider-table>
                <mat-paginator
                  *ngIf="this.totalCount > 0"
                  [pageSizeOptions]="[5, 30, 50, 100, 9999]"
                  [pageSize]="pageSize"
                  [length]="totalCount"
                  [pageIndex]="pageIndex"
                  (page)="pageSizeChange($event)"
                  showFirstLastButtons
                  [selectConfig]="selectConfig"
                  [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
                  aria-label="Select page of periodic elements"
                >
                </mat-paginator>
              </mat-tab>
              <mat-tab label="Declined">
                <fury-service-provider-table
                  [dataSource]="companies"
                  [searchForm]="searchForm"
                  [isLoading]="isLoading"
                  (search)="handleSearch($event)"
                  (handlePaymentInfo)="handlePaymentInfo($event)"
                ></fury-service-provider-table>
                <mat-paginator
                  *ngIf="this.totalCount > 0"
                  [pageSizeOptions]="[5, 30, 50, 100, 9999]"
                  [pageSize]="pageSize"
                  [length]="totalCount"
                  [pageIndex]="pageIndex"
                  (page)="pageSizeChange($event)"
                  showFirstLastButtons
                  [selectConfig]="selectConfig"
                  [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
                  aria-label="Select page of periodic elements"
                >
                </mat-paginator>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </fury-page-layout-content>
</fury-page-layout>
